import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Options } from 'ngx-google-places-autocomplete/objects/options/options';
import { Component, OnInit, ViewChild } from '@angular/core';
import { TemplateSearchCar } from 'src/app/app.models';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { AppService } from 'src/app/app.service';
import { UserServiceService } from 'src/app/services/user-service.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { VehiculeserviceService } from 'src/app/services/vehiculeservice.service';
import { LoginserviceService } from 'src/app/services/loginservice.service';
import { Router } from '@angular/router';
import { ConstatService } from 'src/app/services/constat.service';
import { ToastrService } from 'ngx-toastr';
import { HostService } from 'src/app/services/host.service';
import { VerifResponsiveService } from 'src/app/services/verif-responsive.service';

declare var require: any
const FileSaver = require('file-saver');

@Component({
  selector: 'app-etats-lieux',
  templateUrl: './etats-lieux.component.html',
  styleUrls: ['./etats-lieux.component.scss']
})
export class EtatsLieuxComponent implements OnInit {

   address: string;
   geometry: object;
   options: Options = new Options({
     componentRestrictions: {
       country: "SN",
     },
   });
   public infoFormcoordonnees!: UntypedFormGroup;
   public minDateStart: Date;
   public minDateEnd: Date;
   public currentDateStart?: string;
   public currentDateEnd?: string;
   public showChoice: boolean;
   public showChoiceEnd: boolean;
   public errorAdress: boolean;
   public valueDatePickerEnd?: Date;
   public userIn: any;
   public valeurActio1: any;
   public valeurActio2: any;
   dateStart: any;
   dateEnd: any;
   todayWithPipe: any;
   periodStart?: string;
   periodEnd?: string;
   currentDateFormat?: string;
   templateSearchCar: TemplateSearchCar;
   index: number;
   displayedColumns: string[] = [
     "id",
     "date",
     "declarant",
     "locataire",
     "vehicule",
     "statut",
     "actions",
   ];
   user: any = [];
   customerList: any;
   resultcat: any;
   idcar: number;
   dataSource!: MatTableDataSource<any>;
   @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;
   @ViewChild(MatSort, { static: true }) sort!: MatSort;
   public stores = [
     { id: 1, name: "Store 1" },
     { id: 2, name: "Store 2" },
   ];

   public viewType: string = "list";
   public column: number = 4;
   public p: number = 1;
   
   constructor(
     public appService: AppService,
     public appServices: UserServiceService,
     public snackBar: MatSnackBar,
     public carservice: VehiculeserviceService,
     public loginService: LoginserviceService,
     public router: Router,
     public constatService: ConstatService,
     public formBuilder: UntypedFormBuilder,
     private toastr: ToastrService,
     private hostService:HostService,
     public toast :ToastrService,
    private verifResponsiveService:VerifResponsiveService
     
   ) {}
   ngOnInit() {
     this.infoFormcoordonnees = this.formBuilder.group({
       statut_constat: "",
       id: "",
     });
     this.getCar();
     this.verifResponsiveService.confirmResponsive().subscribe((data) => {
      this.viewType = data ? 'grid' : 'list';
    });
   }
 
   public getCar() {
     
     const storageAuth = localStorage.getItem("user");
     if (storageAuth) {
 
       this.userIn = JSON.parse(storageAuth);
 
     }  else {
 
       this.router.navigate(['login']);
       
     }
     
     this.constatService
       .showAllConstatPro()
       .subscribe((data: any) => {
         this.resultcat = data;
         this.dataSource = new MatTableDataSource<any>(this.resultcat);
         this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
       });
   }
   public clear(id: number) {
     this.infoFormcoordonnees.get("statut_constat")?.setValue("refusé");
     this.infoFormcoordonnees.get("id")?.setValue(this.idcar);
     let valeur = this.infoFormcoordonnees.value;
     this.constatService.updateConstat(valeur).subscribe((data) => {
       //console.log(data);
     });
     this.getCar();
   }
   public visibility(id: number) {
     this.router.navigate(["admin/voir-constat"], {
       queryParams: { code: id },
     });
   }
   public done(id: number) {
     this.infoFormcoordonnees.get("statut_constat")?.setValue("validé");
     this.infoFormcoordonnees.get("id")?.setValue(this.idcar);
     let valeur = this.infoFormcoordonnees.value;
     this.constatService.updateConstat(valeur).subscribe((data) => {
       console.log(data);
     });
     this.getCar();
   }
 
   public deleteConstat(id:number)
   {
       this.constatService.deleteConstat(id).subscribe((data:any)=>{
         //console.log(data);
         this.toastr.success('le constat a été supprimé avec succes ');
         this.getCar();
         //this.router.navigateByUrl('/compte-utilisateur/constat').then();
       },error=>{
         console.log(error);
       })
   }
 
   openDoc(pdfUrl: string, startPage: number ) {
     let linkPdf= this.hostService.getHttpsImage()+pdfUrl;
     window.open(linkPdf + '#page=' + startPage, '_blank', '');
   }
 
   downloadPdf(pdfUrl: string) {
     let linkPdf= this.hostService.getHttpsImage()+'Contrat/'+pdfUrl;
     FileSaver.saveAs(linkPdf);
   }
  
   applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }  

  changeStatus(id:number,status:string)
  {
    this.constatService.updateStatusConstat({id:id,status:status}).subscribe((res:any)=>{
      this.getCar();
      this.toast.success(res.message,'Succès');
    })
  }

  
  public refresh(){
    this.getCar();
  }
 
  changeViewType(viewType:string)
  {
    this.viewType = viewType;
  }

}
